export const GET_MOVE_TYPES_FAIL = "GET_MOVE_TYPES_FAIL";
export const GET_MOVE_TYPES_SUCCESS = "GET_MOVE_TYPES_SUCCESS";
export const GET_MOVE_TYPES_REQUEST = "GET_MOVE_TYPES_REQUEST";
